import declare from "dojo/_base/declare";
import _ from "csi/_base/underscore";
import New from "csi/table/New";
import xml from "csi/xml";
import { ViewWidget } from "csi/view/Widget";
import Query from "csi/xml/Query";

const AggregatePackListItems = declare(New, {

	/**
	 * Filter shipments that are already on PackList.PackListItems out
	 * @param view - the view the action is on
	 */
	applyActionFilters(view: ViewWidget): void {
		const packList = this.getParent();
		const q = new Query();
		
		let addFilter: boolean = false;
		if (packList.Shipments && packList.Shipments.length) {
			_.each(packList.Shipments, (sh) => {
				q.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, sh);
			}, q.Or());
			
			addFilter = true;
		}
		
		if (xml.isValidURL(packList.PurchasedOrder)) {
			q.RefAttr("PO", xml.OP_EQUALS, packList.PurchasedOrder, "Child:Order");
			
			addFilter = true;
		}
		
		if (addFilter) {
			view.relRoot.addQuery(q);
		}

		this.inherited(arguments);
	},
});

export = AggregatePackListItems;
